import { http } from "./http";

const ENDPOINTS = {
  EXCHANGE: "/exchange-rate/",
};

export const exchangeAPI = {
  getExchangeRate: () => http.get(ENDPOINTS.EXCHANGE)
};